function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-doc_svg__a",
  d: "M0 1.333C0 .597.599 0 1.327 0h12.006L20 6.667v16.002c0 .735-.599 1.331-1.328 1.331H1.328A1.328 1.328 0 010 22.667V1.333z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#ECEDEE",
  fillRule: "nonzero",
  d: "M2 1.333C2 .597 2.599 0 3.327 0h12.006L22 6.667v16.002c0 .735-.599 1.331-1.328 1.331H3.328A1.328 1.328 0 012 22.667V1.333z"
}), React.createElement("g", {
  transform: "translate(2)"
}, React.createElement("mask", {
  id: "icon-doc_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#icon-doc_svg__a"
})), React.createElement("path", {
  fill: "#2A6EBB",
  d: "M0 22h20v2H0z",
  mask: "url(#icon-doc_svg__b)"
})), React.createElement("path", {
  fill: "#2A6EBB",
  d: "M7.607 15c-.493 0-.884-.188-1.173-.564-.29-.376-.434-.904-.434-1.584 0-.334.046-.635.14-.902.092-.268.215-.493.37-.677.153-.184.33-.326.528-.426.2-.1.405-.15.617-.15.223 0 .411.04.565.12.154.081.308.191.462.33l-.032-.66V9h.915v5.9h-.756l-.064-.443h-.031c-.144.15-.31.278-.502.384S7.82 15 7.607 15zm.223-.794c.292 0 .565-.153.82-.46v-1.913a1.287 1.287 0 00-.402-.268 1.087 1.087 0 00-.394-.075c-.255 0-.47.117-.644.351-.176.234-.263.568-.263 1.003 0 .446.076.784.227 1.015.15.232.37.347.656.347zm4.496.794a1.74 1.74 0 01-1.293-.56 2.014 2.014 0 01-.41-.677 2.57 2.57 0 01-.15-.91c0-.34.05-.644.15-.911.101-.268.238-.494.41-.677.173-.184.37-.325.593-.422a1.756 1.756 0 011.997.422c.17.183.307.41.41.677.104.267.155.57.155.91 0 .34-.051.644-.155.911-.103.268-.24.493-.41.677a1.69 1.69 0 01-.592.418 1.8 1.8 0 01-.705.142zm0-.786a.771.771 0 00.677-.371c.164-.248.246-.578.246-.99 0-.418-.082-.751-.246-1a.771.771 0 00-.677-.371.762.762 0 00-.672.372c-.162.248-.243.58-.243.998 0 .413.081.743.243.99a.762.762 0 00.672.372zm4.4.786a1.94 1.94 0 01-.743-.142 1.673 1.673 0 01-.601-.418 1.95 1.95 0 01-.398-.677 2.698 2.698 0 01-.143-.91c0-.34.053-.644.159-.911.106-.268.25-.494.43-.677.18-.184.388-.325.624-.422a1.93 1.93 0 01.744-.147c.255 0 .474.045.657.134.183.09.346.198.49.326l-.446.627a1.512 1.512 0 00-.315-.222.732.732 0 00-.338-.08.937.937 0 00-.772.373c-.196.248-.294.58-.294.998 0 .413.097.743.29.99a.911.911 0 00.752.372.934.934 0 00.434-.104c.135-.07.259-.152.37-.246l.374.635a1.93 1.93 0 01-.609.376 1.86 1.86 0 01-.664.125z"
}), React.createElement("path", {
  fill: "#C8CDD0",
  d: "M15.333 0v5.334a1.33 1.33 0 001.333 1.333H22L15.333 0z"
}));

var SvgIconDoc = function SvgIconDoc(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconDoc;